import React from "react";
import { useField } from "formik";

const ATMTextField = ({ label, required = false, extraClassName = "", placeholder, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <div className="relative">
      <label htmlFor={props.id || props.name} className="block text-sm font-medium text-gray-700 mb-1">
        {label}
        {required && <span className="text-red-700"> *</span>}
      </label>

      <input
        {...field}
        {...props}
        id={props.id || props.name}
        required={required}
        placeholder={placeholder}
        className={`${extraClassName} w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-orange-500 ${
          meta.touched && meta.error ? 'border-red-500' : ''
        }`}
      />

      {meta.touched && meta.error && (
        <div className="text-xs text-red-500 mt-1 absolute -bottom-5">{meta.error}</div>
      )}
    </div>
  );
};

export default ATMTextField;